import gql from 'graphql-tag';

const NOTIFICATION_SEND = gql`
mutation notificationSend($input: NotificationSendInput!) {
    notificationSend(input: $input)
  }
`;

export default NOTIFICATION_SEND;